module.exports = __webpack_public_path__ + "static/media/path5.b9149b5f.png";